// extracted by mini-css-extract-plugin
export default {"root":"Jobs_root__h3aj1"};